import { render, staticRenderFns } from "./DashboardEdit.vue?vue&type=template&id=86818742"
import script from "./DashboardEdit.vue?vue&type=script&lang=js"
export * from "./DashboardEdit.vue?vue&type=script&lang=js"
import style0 from "./DashboardEdit.vue?vue&type=style&index=0&id=86818742&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports